export const meetingSlotLabel = slot => {
  if (!Number.isFinite(Date.parse(slot.start)) || !Number.isFinite(Date.parse(slot.end))) return "Aikaa ei voitu varmistaa";
  const format = new Intl.DateTimeFormat("fi-FI", {dateStyle:"short",timeStyle:"short",timeZone:"Europe/Helsinki"});
  return `${format.format(new Date(slot.start))} – ${format.format(new Date(slot.end))} (Suomen aika)`;
};
